export enum UserRoles {
  ADMINISTRACION = 'Administracion',
  PIONEER_LITE = 'PioneerLite',
  PIONEER_LITE_RO = 'PioneerLiteRO',
  PIONEER_PREMIUM = 'PioneerPremium',
  PIONEER_PREMIUM_RO = 'PioneerPremiumRO',
  PIONEER_TRADES = 'PioneerTrades',
  PIONEER_TRADES_RO = 'PioneerTradesRO',
  PROGNOSS = 'Prognoss',
  PROGNOSS_RO = 'PrognossRO',
  ARGENTIA_CLIENTES = 'ArgentiaClientes',
  ARGENTIA_CLIENTES_RO = 'ArgentiaClientesRO',
  ARGENTIA_TRADES = 'ArgentiaTrades',
  ARGENTIA_TRADES_RO = 'ArgentiaTradesRO',
  ARGENTIA_COMERCIAL = 'ArgentiaComercial',
  ARGENTIA_COMERCIAL_RO = 'ArgentiaComercialRO',
  ARGENTIA_SWITCHING = 'ArgentiaSwitching',
  ARGENTIA_SWITCHING_RO = 'ArgentiaSwitchingRO',
  PIONEER_CISTERNAS_LITE = 'PioneerCisternasLite',
  PIONEER_CISTERNAS_LITE_RO = 'PioneerCisternasLiteRO',
  GLOBALSYDE_BASIC = 'GlobalsydeBasic',
  GLOBALSYDE_BASIC_RO = 'GlobalsydeBasicRO',
  TANKS_REPSOL_GESTIONADO = 'TanksRepsolGestionado',
  TANKS_REPSOL_NO_GESTIONADO = 'TanksRepsolNoGestionado',
  TANKS_REPSOL_TPA = 'TanksRepsolTPA',
  ATLAS_ADMIN = 'AtlasAdmin'
}
